import React from 'react';
import PropTypes from 'prop-types';
import FA from 'react-fontawesome';
import { Button, Popover, OverlayTrigger } from 'react-bootstrap';

/**
 * ステータス情報をポップアップで表示するコンポーネント
 */
const StatusInfoPopup = (props) => {
  const renderTooltip = (props) => {
    return (
      <Popover className="large-popopver" arrowProps={props.arrowProps} placement={props.placement} style={props.style} ref={props.ref}>
        <div className="row mb-2">
          <small className="col-12">UNCONFIRMED</small>
        </div>
        <div className="row mb-2">
          <small className="col-12">CONFIRMED</small>
        </div>
        <div className="row mb-2">
          <small className="col-12">EXTERNAL_PROVIDER</small>
        </div>
        <div className="row mb-2">
          <small className="col-12">RESET_REQUIRED</small>
        </div>
        <div className="row mb-2">
          <small className="col-12">FORCE_CHANGE_PASSWORD</small>
        </div>
      </Popover>
    );
  };

  return (
    <OverlayTrigger placement="top" overlay={renderTooltip(props)}>
      <Button className="ml-2 p-0 align-bottom" variant="link"><FA name="info-circle" /></Button>
    </OverlayTrigger>
  );
};
StatusInfoPopup.propTypes = {
  style: PropTypes.object,
  ref: PropTypes.object,
  arrowProps: PropTypes.object,
  placement: PropTypes.string
};
export default StatusInfoPopup;